import styles from "../TeamsManagement/styles.module.css";
import { IExternalAgent } from "./IExternalAgent";

interface IProps {
  agent: IExternalAgent;
  onChange: (updatedAgent: IExternalAgent) => void;
}

/**
 * Name and phone.
 *
 * Both are required by the API, and the phone is what TaskRouter dials — it becomes the
 * worker's contact_uri — so an agent saved without one is routable but unreachable.
 */
const MainInfo = (props: IProps) => {
  return (
    <div>
      <label className={styles.FormLabel} htmlFor="external-agent-name">
        Name
      </label>
      <input
        id="external-agent-name"
        type="text"
        className={styles.FormControl}
        placeholder="External Agent Name"
        // The agent always carries a string here — see emptyExternalAgent(). It used to be
        // read off `{} as IExternalAgent`, so the first render passed value={undefined} and
        // React treated the field as uncontrolled until the operator typed into it.
        value={props.agent.name}
        onChange={(e) => {
          props.onChange({
            ...props.agent,
            name: e.target.value,
          });
        }}
      />
      <label className={styles.FormLabel} htmlFor="external-agent-phone">
        Phone
      </label>
      <input
        id="external-agent-phone"
        type="tel"
        className={styles.FormControl}
        placeholder="Phone"
        value={props.agent.phone}
        onChange={(e) => {
          props.onChange({
            ...props.agent,
            phone: e.target.value,
          });
        }}
      />
    </div>
  );
};

export default MainInfo;
